import {Time, Util} from 'yougile-util'
import {DataObjectId, Hub, Tag, User} from 'yougile-model'
import {Sync} from '@client/sync'
import {ChatUtils} from '@extensions/chat-utils'
import {Project} from '@extensions/project'
import {Sticker, stickerCtl} from '@extensions/sticker/sticker'

export const getBoardName = (board: Hub): string => {
  const box = Sync.getCurrentSandbox()
  const proj = box.get(board.location) as Hub
  return Util.limitStr(proj.title, 50) + ' » ' + Util.limitStr(board.title, 50)
}

export const listBoards = (): Hub[] => {
  const box = Sync.getCurrentSandbox()
  const ttSticker = stickerCtl.Timetracking.getSticker(box)
  const res: Hub[] = []
  Project.listProjects(box.companyId, 'not-archive').forEach(p =>
    Project.listBoards(p, true)
      .filter(b => ttSticker.id in b.stickers)
      .forEach(b => res.push(b))
  )
  return res
}

export const toggleChat = (taskId: DataObjectId): void => {
  const box = Sync.getCurrentSandbox()
  const hub = box.get(taskId) as Hub
  ChatUtils.toggleChat(hub)
}

export const getDateRange = (
  startOffset: number,
  endOffset: number
): [number, number] => {
  const hour24 = 24 * 3600 * 1000
  const start = Time.now() - startOffset * hour24
  const end = Time.now() - endOffset * hour24
  return [start, end]
}

export const getTimeTrackingSticker = (): Tag => {
  const box = Sync.getCurrentSandbox()
  return stickerCtl.Timetracking.getSticker(box)
}

export const getUser = (task: Hub): User | undefined => {
  const box = Sync.getCurrentSandbox()
  const userSticker = stickerCtl.User.getSticker(box)
  if (Sticker.isPinned(userSticker, task)) {
    const userId = task.stickers[userSticker.id] as DataObjectId
    return box.get(userId) as User
  } else {
    return undefined
  }
}
